import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { Route } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useLayerEditable } from "./useLayerEditable";

const ShortestPathButton: React.FC<IButtonProps> = ({ icon, title = "Shortest path" }) => {
  const { map, drawControl } = useContext(MapContext);
  const isLayerEditable = useLayerEditable();

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("shortest_path_feature");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "shortest_path_feature" } as unknown as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton
      title={title}
      value="shortest_path_feature"
      onClick={handleOnClick}
      data-testid="toolbar-shortest-path-button"
      disabled={!isLayerEditable}
    >
      {icon || <Route />}
    </ToolbarToggleButton>
  );
};

export default ShortestPathButton;
